// istanbul ignore file
import styled from 'styled-components';
import { SlideOut } from '@interstate/components/SlideOut';

export const StyledSlideout = styled(SlideOut)`
    .ids-slideout-title-container {
        padding: 20px 16px;
    }
    .ids-slideout-close-button {
        cursor: pointer;
    }
    .card-header-content-container {
        padding: 9px !important;
    }
    .ids-slideout-title {
        display: flex;
        gap: 12px;
        align-items: baseline;
    }
    .recent-deals-title {
        font-weight: 600;
    }
    .ids-SlideOut-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0;
        justify-content: center;
        align-items: center;
    }
    #ids-SlideOut-footer {
        padding: 8px 16px;
        min-height: 0;
        border-top: 1px solid #b2b2b2;
        background-color: rgba(244, 244, 244, 0.96);
        width: 100%;
    }
    .ids-action-buttons-container-rightAligned {
        background-color: transparent;
    }
`;

export const RecentDealsFilter = styled.div`
    padding: 0 16px 12px 16px;
    width: 100%;
`;
